import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export const energyPricesRoutes: Array<RouteObject> = [
  { index: true, lazy: async () => convertRouteModule(await import("./energy-prices")) },
];
